import { render, staticRenderFns } from "./CategoricalLegend.vue?vue&type=template&id=042ec68a&scoped=true&"
import script from "./CategoricalLegend.vue?vue&type=script&lang=js&"
export * from "./CategoricalLegend.vue?vue&type=script&lang=js&"
import style0 from "./CategoricalLegend.vue?vue&type=style&index=0&id=042ec68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ec68a",
  null
  
)

export default component.exports